import { VariableType } from 'json-to-graphql-query';
import type { FieldValue } from './types';

interface GeneratePresignedURLMutation {
  mutation: {
    __variables: {
      formatId: 'String!';
    };
    generatePresignedUrl: {
      __args: {
        formatId: VariableType;
      };
      presignedUrl: FieldValue;
    };
  };
}

export const generatePresignedURL = (truify: boolean = false): GeneratePresignedURLMutation => ({
  mutation: {
    __variables: {
      formatId: 'String!',
    },
    generatePresignedUrl: {
      __args: {
        formatId: new VariableType('formatId'),
      },
      presignedUrl: truify,
    },
  },
});
